import { render, staticRenderFns } from "./complex_doubleTeam.vue?vue&type=template&id=3701bcdd&scoped=true"
import script from "./complex_doubleTeam.vue?vue&type=script&lang=js"
export * from "./complex_doubleTeam.vue?vue&type=script&lang=js"
import style0 from "./complex_doubleTeam.vue?vue&type=style&index=0&id=3701bcdd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3701bcdd",
  null
  
)

export default component.exports